import { useState } from "react";
import useDataFetch, {
  DataFetchOptionsType,
} from "../../../../hooks/useDataFetch";
import { getQuestionAPIresponse } from "../../services";

import RenderLoading from "./partials/renderLoading";
import RenderData from "./partials/renderData";
import RenderError from "./partials/renderError";

const StepThree = () => {
  const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({});
  // const [fetchOptions, setFetchOptions] = useState<DataFetchOptionsType>({
  //   error: { msg: "API Failed" },
  // });
  const { loading, data, error } = useDataFetch(
    getQuestionAPIresponse,
    fetchOptions
  );

  if (loading) {
    return <RenderLoading />;
  }

  if (error) {
    return <RenderError />;
  }

  if (data) {
    return <RenderData questions={data} />;
  }
  return null;
};

export default StepThree;
